import "prebid.js/modules/teadsBidAdapter";

import type {IPrebidJsBidder} from "header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/iPrebidJsBidder";
import type {TeadsAdUnit} from "header-bidding-base/modules/config/domain/bidders/teadsConfig";
import type {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import {Bidders} from "header-bidding-base/modules/header-bidding/domain/bidders";
import {PrebidJsBaseBidder} from "./prebidJsBaseBidder";

export class TeadsBidder extends PrebidJsBaseBidder implements IPrebidJsBidder<TeadsAdUnit> {
    public constructor(config: HeaderBiddingConfig) {
        super(config, Bidders.TEADS);
    }
}
